import React from 'react';
import styled from 'styled-components';
import {KV_ROW_MIN_HEIGHT, kvKeyType, kvValueType, skyTokens} from './design-tokens';

export type KeyValueRow = {key: string; value: string};

const Table = styled.div`
	display: flex;
	flex-direction: column;
	width: 100%;
`;

const Row = styled.div`
	display: flex;
	gap: 8px;
	align-items: center;
	min-height: ${KV_ROW_MIN_HEIGHT}px;
	border-bottom: 1px solid ${skyTokens.color.border.decorative};
	&:last-child {
		border-bottom: none;
	}
`;

// Key / Value share KeyValueForm's type helpers — these read-only rows sit
// directly above the editable ones on the same card, so any drift between the
// two shows up side by side. Previously neither set font-family at all, so both
// inherited the app's global neue-haas-grotesk-text.
const Key = styled.div`
	min-width: 100px;
	${kvKeyType};
`;

const Value = styled.div`
	flex: 1 0 0;
	min-width: 0;
	${kvValueType};
`;

// Stable seam: TNSR-245 drops editable DS inputs in here, keeping the `rows` prop shape.
export function KeyValueTable({rows}: {rows: KeyValueRow[]}): JSX.Element | null {
	if (rows.length === 0) return null;
	return (
		<Table>
			{rows.map(r => (
				<Row key={r.key}>
					<Key>{r.key}</Key>
					<Value>{r.value}</Value>
				</Row>
			))}
		</Table>
	);
}
